import type { FC } from 'react';
import styles from './SeverityBadge.module.scss';

/**
 * Visual weight of a finding, keyed independently of any caller's severity words so a surface can
 * map its own vocabulary onto the same three colours.
 */
export type SeverityLevel = 'high' | 'medium' | 'low';

interface SeverityBadgeProps {
  /** Visual weight; drives the colour only. */
  level: SeverityLevel;
  /** Text shown in the badge, e.g. "critical". Rendered uppercase by CSS. */
  label: string;
  className?: string;
  testId?: string;
}

/** Renders a finding's severity as a coloured pill. */
const SeverityBadge: FC<SeverityBadgeProps> = ({ level, label, className = '', testId }) => {
  return (
    <span
      className={`${styles.badge} ${styles[level]} ${className}`}
      data-test-component="SeverityBadge"
      data-test-element="badge"
      data-test-key={label}
      data-testid={testId}
    >
      {label}
    </span>
  );
};

export default SeverityBadge;
